import React, { useState, useEffect } from 'react'
import {
    CRow,
    CCol,
    CCard,
    CCardHeader,
    CCardBody,
    CBadge,
    CImg,
    CCardFooter,
    CLink
} from '@coreui/react'
import history from '../../../history'

const CanadianProvincialElections = ({match}) => {

    useEffect(() => {
        window.scrollTo(0, 0);
    });

    return (
        <CRow>
            <CCol xs="12" sm="6" md="4">

                <CCard style={{cursor:"pointer"}}>
                    <CCardHeader>
                    <span role="img" aria-label="Canadian Flag" style={{marginRight:"10px"}}>🇨🇦</span>Ontario Elections
                    </CCardHeader>
                    <CCardBody>
                    <CLink to={'/political/canada/provincial/elections/ontario'}>
                    <CImg
                        width='100%'
                        src={'https://geojson-maps.s3.amazonaws.com/images/queens-park.jpg'}
                        alt="Queen's Park in Toronto"
                    />
                    </CLink>
                    </CCardBody>
                    <CCardFooter>
                    <CLink to={'/political/canada/provincial/election/ontario/2003'}><CBadge color="danger" style={{marginLeft:'5px', marginTop:'3px'}} className="float-right">2003</CBadge></CLink>
                    <CLink to={'/political/canada/provincial/election/ontario/2007'}><CBadge color="danger" style={{marginLeft:'5px', marginTop:'3px'}} className="float-right">2007</CBadge></CLink>
                    <CLink to={'/political/canada/provincial/election/ontario/2011'}><CBadge color="danger" style={{marginLeft:'5px', marginTop:'3px'}} className="float-right">2011</CBadge></CLink>
                    <CLink to={'/political/canada/provincial/election/ontario/2014'}><CBadge color="danger" style={{marginLeft:'5px', marginTop:'3px'}} className="float-right">2014</CBadge></CLink>
                    <CLink to={'/political/canada/provincial/election/ontario/2018'}><CBadge color="primary" style={{marginLeft:'5px', marginTop:'3px'}} className="float-right">2018</CBadge></CLink>
                    <CLink to={'/political/canada/provincial/election/ontario/2022'}><CBadge color="primary" style={{marginLeft:'5px', marginTop:'3px'}} className="float-right">2022</CBadge></CLink>
                    </CCardFooter>
                </CCard>
            </CCol>
            <CCol xs="12" sm="6" md="4">

            <CCard style={{cursor:"pointer"}}>
                <CCardHeader>
                <span role="img" aria-label="Canadian Flag" style={{marginRight:"10px"}}>🇨🇦</span>Alberta Elections
                </CCardHeader>
                <CCardBody>
                <CLink to={'/political/canada/provincial/elections/alberta'}>
                <CImg
                    width='100%'
                    src={'https://geojson-maps.s3.amazonaws.com/images/AlbertaLegislature.jpg'}
                    alt="Alberta Legislature in Edmonton"
                />
                </CLink>
                </CCardBody>
                <CCardFooter>
                <CLink to={'/political/canada/provincial/election/alberta/2012'}><CBadge color="primary" style={{marginLeft:'5px', marginTop:'3px'}} className="float-right">2012</CBadge></CLink>
                <CLink to={'/political/canada/provincial/election/alberta/2015'}><CBadge color="warning" style={{marginLeft:'5px', marginTop:'3px'}} className="float-right">2015</CBadge></CLink>
                <CLink to={'/political/canada/provincial/election/alberta/2019'}><CBadge color="primary" style={{marginLeft:'5px', marginTop:'3px'}} className="float-right">2019</CBadge></CLink>
                </CCardFooter>
            </CCard>
        </CCol>            
        </CRow>
    )
  }
  
  export default CanadianProvincialElections;